import { Failure, Success } from "@indietabletop/appkit/async-op";
import { useCallback, useMemo } from "react";
import { useParams } from "wouter";
import { useQuery } from "../database-provider";
import { useRulesets } from "../ruleset-provider/context";

/**
 * Loads the army matching the `armyId` route param from the local database.
 */
export function useArmyQuery() {
  const rulesets = useRulesets();
  const params = useParams<{ armyId: string }>();
  const armyOp = useQuery(
    useCallback((db) => db.getArmy(params.armyId), [params.armyId]),
    `army:${params.armyId}`,
  );

  return useMemo(
    () =>
      armyOp.flatMap((data) => {
        return data
          ? new Success(rulesets.createArmy(data))
          : new Failure({ type: "ARMY_NOT_FOUND" as const });
      }),
    [armyOp, rulesets],
  );
}
